const Testimonials = [
    {
      "name": "Emily Johnson",
      "role": "Interior Designer",
      "review": "Nestora's furniture transformed my living space! High-quality products with beautiful designs. Highly recommend!",
      "rating": 5
    },
    {
      "name": "Michael Lee",
      "role": "Homeowner",
      "review": "Amazing experience with Nestora. The delivery was quick, and the furniture is both stylish and comfortable.",
      "rating": 4.5
    },
    {
      "name": "Sophia Patel",
      "role": "Architect",
      "review": "Impressed by the craftsmanship and attention to detail. The customer service team was very helpful too.",
      "rating": 4
    },
    {
      "name": "James Wilson",
      "role": "Real Estate Agent",
      "review": "My clients are always happy with the furniture I recommend from Nestora. It’s affordable and looks premium.",
      "rating": 4.8
    },
    {
      "name": "Olivia Martinez",
      "role": "Freelance Photographer",
      "review": "Loved the variety of options and the sustainable materials used. The pieces are perfect for my home studio.",
      "rating": 5
    },
    {
      "name": "David Kim",
      "role": "Entrepreneur",
      "review": "Great quality at reasonable prices. The modular furniture fits perfectly in my office space.",
      "rating": 4.2
    }
  ]


export const FAQS = [
  {
    id: 1,
    question: "What is your return policy?",
    answer: "We offer a 30-day return policy on all our furniture items. If you're not completely satisfied with your purchase, you can return it within 30 days for a full refund or exchange. The item must be in its original condition and packaging.",
    isOpen: false
  },
  {
    id: 2,
    question: "How long does delivery take?",
    answer: "Delivery times vary depending on your location and the items ordered. Typically, small items are delivered within 3-5 business days, while larger furniture pieces may take 7-14 business days. You'll receive a delivery estimate at checkout.",
    isOpen: false
  },
  {
    id: 3,
    question: "Do you offer assembly services?",
    answer: "Yes, we offer professional assembly services for an additional fee. You can add this service during checkout. Our trained technicians will assemble your furniture with care and remove all packaging materials.",
    isOpen: false
  },
  {
    id: 4,
    question: "Can I customize my furniture?",
    answer: "We offer customization options for select furniture pieces. This includes fabric choices, wood finishes, and dimensions. Please contact our customer service team to discuss your specific customization needs.",
    isOpen: false
  },
  {
    id: 5,
    question: "Do you ship internationally?",
    answer: "Currently, we ship to the United States and Canada. We're working on expanding our international shipping options. For special international shipping requests, please contact our customer service team.",
    isOpen: false
  }
]
export default Testimonials  